module.exports = "img/flags/BI.9d7f420.png";